import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleSetSelectedCategories,
  handleChangeSortBy,
  handleSetSelectedSentimentValues,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { newsFiltersInitialState } from './initialState/newsInitialState';

export { newsFiltersInitialState as filtersInitialState };
export const newsContentInitialState = {
  filters: newsFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const newsContentSlice = createSlice({
  name: 'newsContentSlice',
  initialState: newsContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, newsFiltersInitialState);
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedCategories: (state, action) => {
      handleSetSelectedCategories(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = newsFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, newsFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedCategories,
  setSelectedContentBasedValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
  setSelectedSentimentValues,
} = newsContentSlice.actions;
